<template>
  <custom-btn-dialog
    btn-text="Affectation"
    width="80vw"
    color="primary"
    v-bind="$attrs"
    icon="search"
    ref="dialog"
    title="Recherche"
  >
    <custom-technician-selector-table
      :entity-id="entityId"
      @input="handleAssignClick"
      :property-id="propertyId"
      :selection="true"
      :request="request"
    />
    <template v-slot:actions>
      <v-btn class="mx-2" small @click="cancel">
        {{ generateMessage('tech_search.cancel') }}
      </v-btn>
    </template>
  </custom-btn-dialog>
</template>

<script>
import { generateMessage } from '@/utils/i18n';
import CustomBtnDialog from '@/components/dialogs/CustomBtnDialog';

import { affectTechnician } from '@/services/api/internal/requestActions/affectation.api';
import CustomTechnicianSelectorTable from '@/components/selects/technician/CustomTechnicianSelectorTable';

export default {
  name: 'eDispatchTechnicianSelectionDialog',
  components: {
    CustomTechnicianSelectorTable,
    CustomBtnDialog,
  },
  props: {
    entityId: { type: String, required: false },
    propertyId: { type: Number, required: true },
    request: { type: Object, required: false },
  },
  methods: {
    generateMessage,
    affectTechnician,
    cancel() {
      this.$refs.dialog.handleCloseClick();
    },
    handleAssignClick(item) {
      this.$emit('affect', item);
      this.cancel();
    },
  },
};
</script>
